<section class="flex justify-between items-center mb-3">
    <h1 class="text-2xl font-bold text-gray-800">Facturas pendientes de Verifactu</h1>
</section>

@if (!configured) {
<div class="mb-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
    Verifactu no está configurado para esta empresa. Configura el certificado digital en Configuración.
</div>
}

<ng-template #numberTmpl let-item="item">
    <span class="font-medium text-sm text-gray-800">{{ item.id_by_company }}/{{ item.year }}</span>
</ng-template>

<ng-template #clientTmpl let-item="item">
    @if (item.client) {
    <span class="text-sm text-gray-800">{{ item.client.name }}</span>
    <span class="block text-xs text-gray-400">{{ item.client.nif }}</span>
    } @else {
    <span class="text-xs text-gray-400 italic">Sin cliente</span>
    }
</ng-template>

<ng-template #totalTmpl let-item="item">
    <span class="font-semibold text-sm text-gray-900">{{ (item.total / 100) | currency:'EUR':'symbol':'1.2-2' }}</span>
</ng-template>

<ng-template #statusTmpl let-item="item">
    <div class="flex gap-2">
        <span class="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium"
        [class.bg-yellow-100]="item.verifactu_status === 'pending'" [class.text-yellow-800]="item.verifactu_status === 'pending'"
        [class.bg-red-100]="item.verifactu_status === 'error'" [class.text-red-800]="item.verifactu_status === 'error'">
        <span class="h-1.5 w-1.5 rounded-full" [class.bg-yellow-500]="item.verifactu_status === 'pending'"
            [class.bg-red-500]="item.verifactu_status === 'error'"></span>
        {{ statusLabels[item.verifactu_status] ?? item.verifactu_status }}
    </span>
    @if (item.verifactu_status === 'error' && item.verifactu_error) {
    <span class="block text-xs text-red-600 mt-1 max-w-xs truncate" [title]="item.verifactu_error">{{ item.verifactu_error }}</span>
    }
    </div>
</ng-template>

<ng-template #actionsTmpl let-item="item">
    <div class="flex justify-end gap-2">
        <button type="button" [disabled]="isLoadingXml(item)" (click)="viewXml(item)"
            class="cursor-pointer px-3 py-1.5 text-xs font-semibold uppercase tracking-wider text-indigo-700 bg-white border border-indigo-200 hover:bg-indigo-50 rounded-lg transition-colors disabled:opacity-50">
            {{ isLoadingXml(item) ? 'Generando...' : 'Ver XML' }}
        </button>

        <button type="button" [disabled]="isSending(item)" (click)="send(item)"
            class="cursor-pointer px-3 py-1.5 text-xs font-semibold uppercase tracking-wider text-white bg-indigo-600 hover:bg-indigo-700 rounded-lg transition-colors disabled:opacity-50">
            {{ isSending(item) ? 'Enviando...' : (item.verifactu_status === 'error' ? 'Reintentar' : 'Enviar') }}
        </button>
    </div>
</ng-template>

<sau-table #sauTable [url]="url" contentList="list" contentTotal="total"
    pageParamName="page" limitParamName="limit" [sizeInitialPage]="1" [sizeBetweenPages]="1" [limit]="20"
    [headers]="headers" [showOptions]="false"
    [customTemplates]="{ 'id_by_company': numberTmpl, 'client': clientTmpl, 'total': totalTmpl, 'verifactu_status': statusTmpl, 'actions': actionsTmpl }"></sau-table>

@if (showXmlModal && xmlPreview) {
<app-custom-modal customTitle="Vista previa del XML de Verifactu" maxWidth="2xl" [hideFooter]="true" (closeFunction)="closeXmlModal()">
    <p class="mb-2 text-xs text-gray-500">
        Esta es una vista previa: el hash y el encadenamiento pueden variar respecto al envío real si otra factura de esta empresa se envía antes.
    </p>
    <pre class="max-h-[60vh] overflow-auto rounded-lg bg-gray-900 p-3 text-xs text-gray-100 whitespace-pre-wrap break-all">{{ xmlPreview }}</pre>
</app-custom-modal>
}
